import { Component, OnInit, OnDestroy } from '@angular/core';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit, OnDestroy {
  public id: number;
  public backgroundColor: string;
  isProduction: boolean;
  title: string;
  isSidebarCollapsed: boolean = false;
  
  constructor(public settingService: SettingsService) {
    this.title = (environment.production ? "Findi ATM Asset Management Solution" : "Findi ATM Asset Management Solution (Demo)")
    this.isProduction = environment.production;
    this.id = settingService.getSidebarImageIndex() + 1;
    this.backgroundColor = settingService.getSidebarColor();
  }

  ngOnInit() {
    this.settingService.sidebarImageIndexUpdate.subscribe((id: number) => {
      this.id = id + 1;
    });
    this.settingService.sidebarColorUpdate.subscribe((color: string) => {
      this.backgroundColor = color;
    });
  }

  ngOnDestroy() {
    this.settingService.sidebarImageIndexUpdate.unsubscribe();
    this.settingService.sidebarColorUpdate.unsubscribe();
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
